import { createSlice } from '@reduxjs/toolkit'

type Props = {
  slideIndex: number
  /** スポットクリック時のタイムスタンプ */
  slideIndexOnClickAt: number
  spotIdToSliceIndex: { spotId: number; sliceIndex: number }[]
  watchId: number
  currentPosition: boolean
  currentCourse: number | 'all' | 'coupon' | 'no_stamp'
  isChangeCurrentCourse: boolean
}

const initialState: Props = {
  slideIndex: 0,
  slideIndexOnClickAt: 0,
  spotIdToSliceIndex: [],
  watchId: 0,
  currentPosition: false,
  currentCourse: 'all',
  isChangeCurrentCourse: false,
}

const spotMapReducer = createSlice({
  name: 'spotMap',
  initialState: initialState,
  reducers: {
    slideIndex(state, action) {
      state.slideIndex = action.payload - 1
    },
    slideIndexOnClickAt(state, action) {
      state.slideIndexOnClickAt = action.payload
    },
    spotIdToSliceIndex(state, action) {
      state.spotIdToSliceIndex = action.payload
    },
    watchId(state, action) {
      state.watchId = action.payload
    },
    currentPosition(state, action) {
      state.currentPosition = action.payload
    },
    currentCourse(state, action) {
      state.currentCourse = action.payload
    },
    isChangeCurrentCourse(state, action) {
      state.isChangeCurrentCourse = action.payload
    },
  },
})

export const {
  slideIndex,
  slideIndexOnClickAt,
  watchId,
  currentPosition,
  currentCourse,
  isChangeCurrentCourse,
  spotIdToSliceIndex,
} = spotMapReducer.actions

export default spotMapReducer.reducer
